import { handleActions, createActions } from 'redux-actions';
import { Map } from 'immutable';

export const { getProductCard } = createActions({
  getProductCard: result => {
    return result;
  }
});

const initState = Map({
  data: []
});

const productCard = handleActions(
  {
    [getProductCard]: (state, action) => {
      return state.set('data', action.payload.product_cards);
    }
  },
  initState
);

export default productCard;
